import React, {useState, useEffect} from "react";
import "./index.css";
import { NewNavbar } from "../../components";
import { BreadCrumbsNew } from "../../components";
import { NewFooter } from "../../components";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { post,get } from "../../services/ApiService";
import PageLoader from "../../components/PageLoader";

const breadcrumbs = [
  { label: "Home", path: "/" },
  { label: "Thank you" },
];


const ThankyouTranscription = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(null);
    const [transcription, setTranscription] = useState(null);
    const [total, setTotal] = useState(0);

    useEffect(() => {
      console.log(id);
      fetchData();
    }, [id]);

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await get(`api/transcriptions/${id}`);
        setIsLoading(false);
        if (response.success) {
          setTranscription(response.transcription);
          setTotal(response.totalPrice);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching drugs:", error);
      }
    };
  return (
    <>
      {isLoading && <PageLoader /> }
      <main id="content" className="wrapper layout-page">
        <div className="breadcrumnb-img-bg general-bg">
          <div className="container">
            <NewNavbar />
            <BreadCrumbsNew breadcrumbs={breadcrumbs} title={"Thank you"} />
          </div>
        </div>
        <div className="container mt-6 mb-10">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="bottom-content mt-15 mb-10">
                {transcription && 
                <div className="row">
                  <div className="col-lg-12">
                    <div className="order-det-box">
                      <h4 className="text-dark">One of our member will contact you soon. and will guide you about the next proces for you transcription.</h4>
                    </div>
                  </div>
                </div>
                }
              </div>
              <ul className="thankyou-list h6-no-border">
                <li>
                  <h6 className="mb-0">Transcription Number:</h6>{" "}
                  <span className="metropill">{transcription?.referenceNumber}</span>
                </li>
                <li>
                  <h6 className="mb-0">Date:</h6>{" "}
                  {transcription && transcription.createdAt && (
                    <span className="metropill">
                      {new Date(transcription.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  )}

                </li>
                <li>
                  <h6 className="mb-0">Customer Name:</h6>{" "}
                  <span className="metropill">{transcription?.patientId?.name}</span>
                </li>
              </ul>
              <div className="head-details mb-5">
                <div className="row">
                  <div className="col-lg-6 col-6">
                    <h4>Description</h4>
                  </div>
                  <div className="col-lg-3 d-none d-lg-block"></div>
                  <div className="col-lg-3 col-6">
                    <h4>Price</h4>
                  </div>
                </div>
              </div>
              <div className="product-body">
                {transcription && transcription.drugs.length > 0 && 
                  <>
                  {/* <div className="body-tr"> */}
                    <div className="row">
                      <div className="col-lg-6">
                        <h4 className="m-0 p-0">
                          Transcription Conversion Fee
                        </h4>
                      </div>
                      <div className="col-lg-3"></div>
                      <div className="col-lg-3 my-auto">
                        <h4 className="metropill-thin">£{total}</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <hr className="" />
                      </div>
                    </div>
                  {/* </div> */}

                  <div className="row">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3">
                      <h4 className="text-end">Total:</h4>
                    </div>
                    <div className="col-lg-3">
                      <h4 className="metropill-thin">£{total}</h4>
                      <hr className="" />
                    </div>
                  </div>
                  </>
                }
              </div>

              <div className="mt-30 mb-4 p-0 card-footer bg-transparent border-0 d-flex align-items-center justify-content-center gap-2">
                <Link to={`/`} className="btncust w-auto activebg m-auto">Back to Home</Link>
              </div>
            </div>
          </div>
        </div>
        <NewFooter />
      </main>
    </>
  );
};

export default ThankyouTranscription;